<template>
    <div class="content-body customers-wrapper transaction-history">
        <b-row>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <b-input-group>
                    <b-input-group slot="append">
                        <i class="icon-calendar"></i>
                    </b-input-group>
                    <datepicker
                        :config="daterangeConfig">
                    </datepicker>
                </b-input-group>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <div class="filter-wrapper">
                    <b-input-group prepend=" ">
                        <b-form-input placeholder="Search"></b-form-input>
                        <b-dropdown text="Advanced" variant="primary" slot="append">
                            <b-dropdown-item>Action A</b-dropdown-item>
                            <b-dropdown-item>Action B</b-dropdown-item>
                        </b-dropdown>
                    </b-input-group>
                </div>
            </b-col>
        </b-row>
        <div class="mt-3">
            <div class="data-container">
                <b-table :items="billingAccount"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    responsive>
                </b-table>
            </div>
        </div>
        <div>
            <b-row>
                <b-col>
                    <div class="mt-1">
                        <span class="pagination-indicator">1-{{ totalRows }} of 100 per page</span>
                        
                        <b-pagination
                            hide-goto-end-buttons
                            align="left"
                            size="md"
                            :limit="3"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            v-model="currentPage"
                            class="custom-pagination-arrow-only mb-0 ml-2">
                        </b-pagination>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import "../../plugins/vue-currency-filter";
import Datepicker from "vue-bulma-datepicker";
const billingAccount = [
    {
        account_no: "0000001",
        outstanding_balance: "PHP 1200.00",
        due_date: "Aug 1, 2018",
        business_name: "Bistro Group",
        location: "BGC",
        representative: "Jose Rizal"
    },
    {
        account_no: "0000002",
        outstanding_balance: "PHP 2400.25",
        due_date: "Aug 2, 2018",
        business_name: "Bistro Group 2",
        location: "Makati",
        representative: "Andres Bonifacio"
    }
];
export default {
    name: "BillingAccount",
    components: {
        Datepicker
    },
    data() {
        return {
            billingAccount: billingAccount,
            currentPage: 1,
            perPage: 10,
            totalRows: billingAccount.length,
            fields: [
                {
                    key: "account_no",
                    label: "Account No.",
                    sortable: true
                },
                {
                    key: "outstanding_balance",
                    label: "Outstanding Balance",
                    sortable: true
                },
                {
                    key: "due_date",
                    label: "Due Date",
                    sortable: true
                },
                {
                    key: "business_name",
                    label: "Business Name",
                    sortable: true
                },
                {
                    key: "location",
                    label: "Location",
                    sortable: true
                },
                {
                    key: "representative",
                    label: "Representative",
                    sortable: true
                }
            ],
            daterangeConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d",
                static: true,
                mode: "range",
                defaultDate: ["today", "today"]
                // onChange: function(selectedDates, dateStr) {
                //     console.log(selectedDates, dateStr);
                // }
            }
        };
    }
};
</script>
